import React from 'react';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import If from 'Views/Components/If/If';
import { Link } from 'react-router-dom';
import { BookingEntity } from 'Models/Entities';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface ViewOtherBookingButtonProps {
	booking: BookingEntity;
	refresh: () => void;
}

export function ViewOtherBookingButton({ booking, refresh }: ViewOtherBookingButtonProps) {
	const returnBookingId = booking.returnBooking?.id ?? booking.returnBookingForId;

	const linkedBookingDirection = isNotNullOrUndefined(booking.returnBooking) ? 'returning' : 'departing';

	return (
		<>
			<If condition={isNotNullOrUndefined(returnBookingId)}>
				<Link
					className="view-return-ticket__button"
					to={`/bookings/${returnBookingId}`}
					onClick={() => refresh()}
				>
					<Icon name="confirmation_number" useMaterialIcons />
					<FormattedMessage
						id="booking-details__view-other-booking-button__label"
						defaultMessage="View {bookingDirection} ticket"
						values={{
							bookingDirection: linkedBookingDirection,
						}}
					/>
					<Icon name="chevron_right" useMaterialIcons />
				</Link>
			</If>
		</>
	);
}
